import React from 'react';
import { Dossier } from './dossier/Dossier';
import { BaseBox } from '@components/common/box/base/BaseBox';
import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';
import { TestId } from '@components/test-ids';
import { TourDossier } from '@model/tours';

export interface TourDossiersProps {
  dossiers: Array<TourDossier>;
  className?: string;
}

const Container: any = styled(BaseBox)({
  width: '100%',
  display: 'block',
  padding: 0,
  [mq.medium]: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  }
});

export const TourDossiers = ({ dossiers, className }: TourDossiersProps) => {
  const renderDossiers = () => dossiers.map((dossier: TourDossier) => <Dossier key={dossier.name} {...dossier} />);
  return (
    <Container className={className} testId={TestId.tourDossiers.container}>
      {renderDossiers()}
    </Container>
  );
};
